import { useEffect, useState } from "react";

import { LinkButton } from "@client:common/button";
import { Model } from "@client:common/Model";
import { Ripple } from "@client:common/effects/ripple";
import { Theme } from "@client:common/Theme";
import { GlobalStore } from "@client:common/global-store";
import { applyFilters, Filter } from "@client:common/filtering";


import ModelCards from "./views/model-cards/ModelCards";
import FilterBar from "./views/filter-bar/FilterBar";


import "./LandingPage.light.scss";
import "./LandingPage.dark.scss";

interface Props {
  models: Model[];
}

export function LandingPage(props: Props) {
  const [currentTheme, setCurrentTheme] = useState(Theme.DARK);
  const [scrollValue, setScrollValue] = useState(0);

  const onScroll = (e: any) => {
    const currentScrollY = e.target.scrollTop;
    setScrollValue(currentScrollY);
  };

  const [filters, setFilters] = useState<Filter[]>([]);

  const shownModels = applyFilters(props.models, filters);

  useEffect(() => {
    const globalStore = GlobalStore.getInstance();
    const subscription = globalStore.select("currentTheme").subscribe({
      next: setCurrentTheme
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);
  return (
    <div className="landing-page">
      <header className="landing-page__header">
        <div className="landing-page__header-info-container">
          {scrollValue < 20 && (
            <div className="landing-page__header-column">
              <h1 className="landing-page__site-name">
                Model Selection Platform for Energy Storage
              </h1>
              MSP reviews and compares energy storage tools developed at the
              Energy Department&apos;s national labs and helps users identify
              the most suitable valuation tools for their needs
            </div>
          )}

          <div className="landing-page__button-column">
            <LinkButton
              to="/pages/selection-wizard"
              className="landing-page__find-best-match"
              style="raised"
              color="primary"
            >
              <Ripple />
              FIND BEST MATCH
            </LinkButton>
            <LinkButton
              to="/pages/model-comparator"
              style="stroked"
              color="primary"
              className="landing-page__view-model-comparison"
            >
              <Ripple />
              VIEW MODEL COMPARISON TABLE
            </LinkButton>
          </div>
        </div>
        <FilterBar
          filters={filters}
          setFilters={setFilters} />
      </header>
      <div
        className="model-cards-wrapper"
        onScroll={onScroll}>
        <div className="results-count">
          {`${shownModels.length} result${shownModels.length > 1 ? 's' : ''}`}
        </div>
        <ModelCards
          models={shownModels}
          currentTheme={currentTheme} />
      </div>
    </div>
  );
}
